module.exports = __webpack_public_path__ + "assets/img/系统开放.c4d8dfb5.jpg";